

































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";
import { ROUTE_NAMES } from "../../router/routenames";
import { api as friendsApi } from "../../store/modules/friends";
import { api as userApi } from "../../store/modules/user";
import { CurrentUser } from "../../store/modules/friends/types";
import { FriendRef } from "@dokogd/shared";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoDialogPlayers extends Vue {
  @Action(friendsApi.actions.listenForFriends, {
    namespace: friendsApi.namespace,
  })
  listenForFriends!: () => Promise<void>;

  @Action(friendsApi.actions.stopListenForFriends, {
    namespace: friendsApi.namespace,
  })
  stopListenForFriends!: () => Promise<void>;

  @Getter(friendsApi.getters.getFriends, { namespace: friendsApi.namespace })
  list!: FriendRef[];

  @Getter(userApi.getters.getCurrentUser, { namespace: userApi.namespace })
  currentUser!: CurrentUser | null;

  @Getter(userApi.getters.getAvatarId, { namespace: userApi.namespace })
  avatarId!: string;

  navToProfileEdit() {
    this.$router.push({
      name: ROUTE_NAMES.PROFILE_EDIT,
    });
  }

  created() {
    this.listenForFriends();
  }

  beforeDestroy() {
    this.stopListenForFriends();
  }
}
